<template>
  <div class="parameters-page">
    <PageHeader
      title="FAQ > Paramètres"
      description="Gestion des types et des catégories de la FAQ"
    />
    <QuestionsSubmenu />
    <PageContent>
  <div class="parameters-content flex flex-wrap gap-8 mt-8">
        <div class="bg-white rounded-lg shadow p-6 flex-1 min-w-[350px] mb-6">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold">Types</h2>
            <div class="flex items-center gap-2">
              <button
                @click="toggleTypeAlpha"
                class="px-3 py-2 rounded text-sm border transition font-medium"
                :class="typeAlphaActive ? 'bg-blue-600 text-white border-blue-600' : 'bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200'"
                title="Trier alphabétiquement"
              >
                <span v-if="typeAlphaAsc">A→Z</span>
                <span v-else>Z→A</span>
              </button>
              <button
                @click="toggleTypeOriginal"
                class="px-3 py-2 rounded text-sm border transition flex items-center gap-1 font-medium"
                :class="!typeAlphaActive ? 'bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200' : 'bg-gray-100 text-gray-400 border-gray-200'"
                :title="typeOriginalReverse ? 'Ordre: plus récent en premier' : 'Ordre: plus ancien en premier'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 8v4l2 2"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
                <span class="text-[10px] font-medium" :class="typeOriginalReverse ? 'opacity-100' : 'opacity-50'">⇅</span>
              </button>
            </div>
          </div>
          <div>
            <div v-if="isAdmin" class="flex gap-2 mb-3">
              <input
                v-model="newType"
                @keyup.enter="addType"
                placeholder="Ajouter un type..."
                class="flex-1 px-2 py-1 border border-gray-300 rounded"
              />
              <button
                @click="addType"
                :disabled="!newType.trim()"
                class="px-3 py-1 bg-blue-600 text-white rounded disabled:bg-gray-300"
              >Ajouter</button>
            </div>
            <div
              v-for="type in paginatedTypes"
              :key="type.uuid"
              class="flex items-center gap-2 mb-1"
            >
              <input
                v-model="type.name"
                @blur="updateType(type)"
                @keyup.enter="updateType(type)"
                class="flex-1 px-2 py-1 border border-gray-200 rounded bg-gray-50"
              />
              <!--
              <button
                @click="deleteType(type)"
                title="Supprimer"
                class="px-2 py-1 rounded hover:bg-red-50"
              ><span class="text-red-600 text-lg font-bold">×</span></button>
              -->
            </div>
            <div
              class="flex items-center gap-3 mt-4 justify-end"
              v-if="types.length > pageSize"
            >
              <button
                @click="typePage--"
                :disabled="typePage === 1"
                class="px-3 py-2 rounded border border-gray-200 bg-gray-100 disabled:bg-gray-200 flex items-center justify-center text-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                ><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
              </button>
              <span class="text-sm font-medium">Page {{ typePage }} / {{ typeTotalPages }}</span>
              <button
                @click="typePage++"
                :disabled="typePage === typeTotalPages"
                class="px-3 py-2 rounded border border-gray-200 bg-gray-100 disabled:bg-gray-200 flex items-center justify-center text-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                ><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" /></svg>
              </button>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow p-6 flex-1 min-w-[350px] mb-6">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold">Catégories</h2>
            <div class="flex items-center gap-2">
              <button
                @click="toggleCategoryAlpha"
                class="px-3 py-2 rounded text-sm border transition font-medium"
                :class="categoryAlphaActive ? 'bg-blue-600 text-white border-blue-600' : 'bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200'"
                title="Trier alphabétiquement"
              >
                <span v-if="categoryAlphaAsc">A→Z</span>
                <span v-else>Z→A</span>
              </button>
              <button
                @click="toggleCategoryOriginal"
                class="px-3 py-2 rounded text-sm border transition flex items-center gap-1 font-medium"
                :class="!categoryAlphaActive ? 'bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200' : 'bg-gray-100 text-gray-400 border-gray-200'"
                :title="categoryOriginalReverse ? 'Ordre: plus récent en premier' : 'Ordre: plus ancien en premier'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 8v4l2 2"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke-width="2"
                    fill="none"
                  />
                </svg>
                <span class="text-[10px] font-medium" :class="categoryOriginalReverse ? 'opacity-100' : 'opacity-50'">⇅</span>
              </button>
            </div>
          </div>
          <div>
            <div class="flex gap-2 mb-3">
              <input
                v-model="newCategory"
                @keyup.enter="addCategory"
                placeholder="Ajouter une catégorie..."
                class="flex-1 px-2 py-1 border border-gray-300 rounded"
              />
              <button
                @click="addCategory"
                :disabled="!newCategory.trim()"
                class="px-3 py-1 bg-blue-600 text-white rounded disabled:bg-gray-300"
              >Ajouter</button>
            </div>
            <div
              v-for="category in paginatedCategories"
              :key="category.uuid"
              class="flex items-center gap-2 mb-1"
            >
              <input
                v-model="category.label"
                @blur="updateCategory(category)"
                @keyup.enter="updateCategory(category)"
                class="flex-1 px-2 py-1 border border-gray-200 rounded bg-gray-50"
              />
              <button
                @click="deleteCategory(category)"
                title="Supprimer"
                class="px-2 py-1 rounded hover:bg-red-50"
              ><span class="text-red-600 text-lg font-bold">×</span></button>
            </div>
            <div
              class="flex items-center gap-3 mt-4 justify-end"
              v-if="categories.length > pageSize"
            >
              <button
                @click="categoryPage--"
                :disabled="categoryPage === 1"
                class="px-3 py-2 rounded border border-gray-200 bg-gray-100 disabled:bg-gray-200 flex items-center justify-center text-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                ><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
              </button>
              <span class="text-sm font-medium">Page {{ categoryPage }} / {{ categoryTotalPages }}</span>
              <button
                @click="categoryPage++"
                :disabled="categoryPage === categoryTotalPages"
                class="px-3 py-2 rounded border border-gray-200 bg-gray-100 disabled:bg-gray-200 flex items-center justify-center text-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                ><path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" /></svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import PageContent from '@/components/PageContent.vue'
import QuestionsSubmenu from './QuestionsSubmenu.vue'
import { http } from '@/services/api.service'
import { mapGetters } from 'vuex'

export default {
  name: 'app-question-parameters',
  components: {
    PageHeader,
    PageContent,
    QuestionsSubmenu
  },
  data () {
    return {
      types: [],
      categories: [],
      newType: '',
      newCategory: '',
      typePage: 1,
      categoryPage: 1,
      pageSize: 10,
      typeAlphaActive: false,
      typeAlphaAsc: true,
      typeOriginalReverse: true,
      categoryAlphaActive: false,
      categoryAlphaAsc: true,
      categoryOriginalReverse: true
    }
  },
  created () {
    this.getTypes()
    this.getCategories()
  },
  computed: {
    ...mapGetters(['roles']),
    normalizedRoles () {
      const roles = this.roles || []
      if (!Array.isArray(roles)) {
        return []
      }
      return roles
        .map(role => {
          if (typeof role === 'string') {
            return role.toLowerCase()
          }
          if (role && typeof role.name === 'string') {
            return role.name.toLowerCase()
          }
          return ''
        })
        .filter(Boolean)
    },
    isAdmin () {
      return this.normalizedRoles.includes('admin')
    },
    paginatedTypes () {
      let arr = [...this.types]
      if (this.typeAlphaActive) {
        arr.sort((a, b) => {
          if (!a.name || !b.name) return 0
          return a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' })
        })
        if (!this.typeAlphaAsc) arr.reverse()
      } else if (this.typeOriginalReverse) {
        arr = arr.slice().reverse()
      }
      const start = (this.typePage - 1) * this.pageSize
      return arr.slice(start, start + this.pageSize)
    },
    typeTotalPages () {
      return Math.ceil(this.types.length / this.pageSize) || 1
    },
    paginatedCategories () {
      let arr = [...this.categories]
      if (this.categoryAlphaActive) {
        arr.sort((a, b) => {
          if (!a.label || !b.label) return 0
          return a.label.localeCompare(b.label, 'fr', { sensitivity: 'base' })
        })
        if (!this.categoryAlphaAsc) arr.reverse()
      } else if (this.categoryOriginalReverse) {
        arr = arr.slice().reverse()
      }
      const start = (this.categoryPage - 1) * this.pageSize
      return arr.slice(start, start + this.pageSize)
    },
    categoryTotalPages () {
      return Math.ceil(this.categories.length / this.pageSize) || 1
    }
  },
  methods: {
    getTypes () {
      http.get('/faq/type').then(res => {
        this.types = res.data
      })
    },
    addType () {
      if (!this.isAdmin) {
        this.$buefy.notification.open({
          duration: 3500,
          message: 'Accès réservé aux administrateurs.',
          position: 'is-bottom-left',
          type: 'is-danger',
          hasIcon: true
        })
        return
      }
      if (!this.newType.trim()) return
      http.post('/faq/type', { name: this.newType }).then(res => {
        this.types.unshift(res.data)
        this.newType = ''
        this.typePage = 1
      })
    },
    updateType (type) {
      http.put(`/faq/type/${type.uuid}`, { name: type.name })
    },
    deleteType (type) {
      this.$buefy.dialog.confirm({
        message: `Êtes-vous sûr de vouloir supprimer le type « ${type.name} » ?`,
        confirmText: 'Supprimer',
        type: 'is-danger',
        cancelText: 'Annuler',
        onConfirm: () => {
          http.delete(`/faq/type/${type.uuid}`).then(() => {
            this.types = this.types.filter(t => t.uuid !== type.uuid)
          })
        }
      })
    },
    getCategories () {
      http.get('/faq/category').then(res => {
        this.categories = res.data
      })
    },
    addCategory () {
      if (!this.newCategory.trim()) return
      http.post('/faq/category', { label: this.newCategory }).then(res => {
        this.categories.unshift(res.data)
        this.newCategory = ''
        this.categoryPage = 1
      })
    },
    updateCategory (category) {
      http.put(`/faq/category/${category.uuid}`, { label: category.label })
    },
    deleteCategory (category) {
      this.$buefy.dialog.confirm({
        message: `Êtes-vous sûr de vouloir supprimer la catégorie « ${category.label} » ?`,
        confirmText: 'Supprimer',
        type: 'is-danger',
        cancelText: 'Annuler',
        onConfirm: () => {
          http.delete(`/faq/category/${category.uuid}`).then(() => {
            this.categories = this.categories.filter(c => c.uuid !== category.uuid)
          })
        }
      })
    },
    toggleTypeAlpha () {
      if (!this.typeAlphaActive) {
        this.typeAlphaActive = true
        this.typeAlphaAsc = true
      } else {
        this.typeAlphaAsc = !this.typeAlphaAsc
      }
    },
    toggleTypeOriginal () {
      if (this.typeAlphaActive) this.typeAlphaActive = false
      this.typeOriginalReverse = !this.typeOriginalReverse
    },
    toggleCategoryAlpha () {
      if (!this.categoryAlphaActive) {
        this.categoryAlphaActive = true
        this.categoryAlphaAsc = true
      } else {
        this.categoryAlphaAsc = !this.categoryAlphaAsc
      }
    },
    toggleCategoryOriginal () {
      if (this.categoryAlphaActive) this.categoryAlphaActive = false
      this.categoryOriginalReverse = !this.categoryOriginalReverse
    }
  }
}
</script>
